// eslint-disable-next-line filenames/match-exported
import { LiaKeySolid } from "react-icons/lia";
import { TbBrandSlack, TbChartBar, TbDatabase, TbGitBranch, TbMessageDots, TbRobot } from "react-icons/tb";
import { VscRocket } from "react-icons/vsc";

import { ComponentWithAs, IconProps } from "@chakra-ui/react";

import { TerminalIcon } from "@/components/shared/ReleaseIcons";

export const agentsMenuItems = [
  {
    label: "Quickstart",
    icon: VscRocket as ComponentWithAs<"svg", IconProps>,
    slug: "quickstart",
  },
  {
    label: "Agents",
    icon: TbRobot as ComponentWithAs<"svg", IconProps>,
    slug: "agents_list",
  },
  {
    label: "Sessions",
    icon: TbMessageDots as ComponentWithAs<"svg", IconProps>,
    slug: "sessions",
  },
  {
    label: "Workflows",
    icon: TbGitBranch as ComponentWithAs<"svg", IconProps>,
    slug: "workflows",
  },
  {
    label: "Slack Messaging",
    icon: TbBrandSlack as ComponentWithAs<"svg", IconProps>,
    slug: "slack_messaging",
  },
  {
    label: "Metrics",
    icon: TbChartBar as ComponentWithAs<"svg", IconProps>,
    slug: "metrics",
  },
  "Resources",
  {
    label: "Environments",
    icon: TerminalIcon,
    slug: "environments",
  },
  {
    label: "Credential Vaults",
    icon: LiaKeySolid as ComponentWithAs<"svg", IconProps>,
    slug: "credential_vaults",
  },
  {
    label: "Memory Stores",
    icon: TbDatabase as ComponentWithAs<"svg", IconProps>,
    slug: "memory_stores",
  },
] as const;

type ExtractSlug<T> = T extends { slug: infer S } ? S : never;
export type AgentsMenuItem = ExtractSlug<(typeof agentsMenuItems)[number]>;
